const blogs = {
    mixins: [mixins],
    data() {
        return {
            handler: "",
            errorDialog: false,
            errorMsgs: [],
            records: [],
            featuredNews: [],
            loading: true,
            page: 1,
            allItems: 0,
        };
    },
    mounted() {
        this.doSearch();
    },
    methods: {
        reset() {
            this.records = [];
            this.page = 1;
        },

        doSearch() {
            this.errorMsgs = [];

            try {
                axios
                    .get(this.handler + "?page=" + this.page)
                    .then((response) => {
                        var { hasError, errorMessages, data, allItems } = response.data;

                        if (hasError) {
                            this.handleError(errorMessages);
                            return false;
                        }

                        var filteredData = data.filter((x) => x.isRecent === false);

                        var feat = data.filter((x) => x.isRecent === true);

                        this.handleSuccess(filteredData, allItems, feat);
                    })
                    .catch((errors) => {
                        this.handleError([errors]);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            } catch (err) {
                this.loading = false;
                this.handleError(JSON.parse(err));
            }
        },

        //if server has errors show them
        handleError(messages) {
            this.errorMsgs = this.hasValue(messages) ? messages : [];
            this.errorDialog = true;
        },

        //if server has not errors
        handleSuccess(filteredData, allItems, feat) {
            this.records = [];
            this.featuredNews = [];

            this.$nextTick(() => {
                this.allItems = parseInt(allItems);

                this.featuredNews = [].concat(...feat);

                this.records = [].concat(...filteredData);
            });
        },

        pageChanged(newPage) {
            this.page = newPage;

            this.doSearch();
            this.scrollToElem(jQuery(".s-blogs__results"), 200);
        },
    },
    computed: {},
};

var blogsApp = Vue.createApp(blogs);
if (document.querySelector("#v-blogs")) {
    blogsApp.directive("init", initDirective);
    blogsApp.component("b-pagination", bPagination);
    blogsApp.component("alert-danger", alertDanger);
    blogsApp.mount("#v-blogs");
}
